import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { Scenario } from '../../types/scenario-modeling.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useDuplicate = () => {
  const { mutate: duplicate, isPending } = useIdempotentAppMutation<
    Scenario,
    HttpException,
    { scenarioId: string }
  >([QueryKey.DUPLICATE_SCENARIO], {
    mutationFn: ({ scenarioId }: { scenarioId: string }, { headers }) =>
      ApiService.post(
        { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'duplicate'] },
        { headers },
      ),
  });
  return { duplicate, isPending };
};
